import { useState, useEffect } from 'react';

const useTheme = () => {
    const [currentTheme, setCurrentTheme] = useState('DEFAULT');
    const [themeConfig, setThemeConfig] = useState(null);

    // Configuração de classes por tema e componente
    const themeConfigs = {
        'DEFAULT': {
            header: 'bundlecabecalho',
            body: 'theme-default',
            boxLogin: 'bundleBox1',
            button: 'bundleFloat',
            loader:'loader',
        },
        'MULTICHANNEL': {
            header: 'bundlecabecalho',
            body: 'theme-default',
            boxLogin: 'bundleBox1',
            button: 'bundleFloat',
            loader:'loader',
        },
        'ITAU_UNICLASS': {
            header: 'bundlecabecalho bundlecabecalho-itau-uniclass',
            body: 'theme-itau',
            boxLogin: 'bundleBox1 bundleBox1Itau',
            button: 'bundleFloat buttonItau',
            loader:'loader loader-itau',
        },
        'ITAU_PERSONALITE': {
            header: 'bundlecabecalho bundlecabecalho-itau-personalite',
            body: 'theme-itau',
            boxLogin: 'bundleBox1 bundleBox1Itau',
            button: 'bundleFloat buttonItau',
            loader:'loader loader-itau',
        }
    };

    useEffect(() => {
        const getThemeFromUrl = () => {
            try {
                const urlParams = new URLSearchParams(window.location.search);
                const rParam = urlParams.get('r');
                
                if (!rParam) {
                    setCurrentTheme('DEFAULT');
                    setThemeConfig(themeConfigs['DEFAULT']);
                    return;
                }

                const decoded = atob(rParam);
                console.log('Tema detectado:', decoded);

                const themeNames = ['MULTICHANNEL', 'ITAU_UNICLASS', 'ITAU_PERSONALITE'];
                
                if (themeNames.includes(decoded)) {
                    setCurrentTheme(decoded);
                    setThemeConfig(themeConfigs[decoded]);
                } else {
                    setCurrentTheme('DEFAULT');
                    setThemeConfig(themeConfigs['DEFAULT']);
                }
            } catch (error) {
                console.error('Erro ao decodificar parâmetro r:', error);
                setCurrentTheme('DEFAULT');
                setThemeConfig(themeConfigs['DEFAULT']);
            }
        };

        getThemeFromUrl();
    }, []);

     // Aplicar classe no body automaticamente
     useEffect(() => {
        if (themeConfig && themeConfig.body) {
            // Remove todas as classes de tema anteriores
            document.body.classList.remove('theme-default', 'theme-multichannel', 'theme-itau-uniclass', 'theme-itau-personalite');
            
            // Adiciona a nova classe
            document.body.classList.add(themeConfig.body);
        }
    }, [themeConfig]);

    // Função para pegar classe de um componente específico
    const getThemeClass = (componentName) => {
        if (!themeConfig || !themeConfig[componentName]) {
            return themeConfigs['DEFAULT'][componentName] || '';
        }
        return themeConfig[componentName];
    };

    // Função para pegar múltiplas classes de uma vez
    const getThemeClasses = (componentNames) => {
        const classes = {};
        componentNames.forEach(name => {
            classes[name] = getThemeClass(name);
        });
        return classes;
    };

    return { 
        currentTheme,
        getThemeClass,
        getThemeClasses,
    };
};

export default useTheme;